import moment from "moment"

export default {
  "loginForm": {
    "username": "Phone Number or Email",
    "password": "Password",

    "usernamePlaceholder": "Phone number with country code or Email",
    "passwordPlaceholder": "Password",

    "phoneExample": "Ex: +62896123465659"
  },

  "passwordResetForm": {
    "email": "Email",

    "emailPlaceholder": "Input your email"
  },

  "farmForm": {
    "name": "Farm Name",
    "area": "Area (m²)",
    "countryId": "Country",
    "regionId": "City or district",
    "provinceId": "Province",
    "regencyId": "City/Regency",
    "districtId": "District",
    "villageId": "Sub District",
    "address": "Address",
    "currencyId": "Currency",
    "timezone": "Time Zone",
    "farmTooltip": "Write down your farm name here",
    "farmTooltip2": "Write down your farm address here",
    "farmTooltip3": "Write down your farm data here",

    "namePlaceholder": "Farm Name",
    "areaPlaceholder": "-",
    "countryIdPlaceholder": "Select Country",
    "regionIdPlaceholder": "Select City or district",
    "provinceIdPlaceholder": "Select Province",
    "regencyIdPlaceholder": "Select City or Regency",
    "districtIdPlaceholder": "Select District",
    "villageIdPlaceholder": "Select Sub District",
    "addressPlaceholder": "Block name, street name, other information",
    "currencyIdPlaceholder": "Select Currency",
    "timezonePlaceholder": "Select Time Zone",

    "deleteSubtitle": "Data cycle, pond, and farm will be deleted and you can't access it again.",
    "createFarm": "Create Farm"
  },

  "pondForm": {
    "farmId": "Farm",
    "title": "Create pond(s) for",
    "totalPonds": "Total Ponds",
    "namePrefix": "Pond Name Prefix",
    "name": "Pond Name",
    "type": "Pond Type",
    "length": "Pond Length (m)",
    "width": "Pond Width (m)",
    "area": "Pond Area (m²)",
    "deep": "Depth (m)",
    "diameter": "Pond Diameter (m)",

    "farmIdPlaceholder": "-",
    "totalPondsPlaceholder": " ",
    "namePrefixPlaceholder": " ",
    "namePlaceholder": " ",
    "typePlaceholder": " ",
    "lengthPlaceholder": " ",
    "widthPlaceholder": " ",
    "areaPlaceholder": " ",
    "deepPlaceholder": " ",

    "namePrefixHelper": "Ponds number will automatically following the total ponds",

    "totalPondsMaxMessage": "Free version maximum is %{max} ponds. More of that, you can add it in the webapp",

    "pond": "Pond",
    "formTitle": "List Pond",
    "formSubtitle": "Change the pond area to the actual count so that the estimation system is more suitable."
  },

  "cycleForm": {
    "id": "Cycle",
    "farmId": "Farm",
    "pondId": "Pond",
    "totalSeed": "Total Seed (tail)",
    "totalSeedType": "Total Seed Type",
    "startedAt": "Started At",
    "finishedAt": "Finished At",
    "initialAge": "Initial Age (days)",
    "preparationDay": "Preparation Day (days)",
    "hatcheryId": "Hatchery",
    "speciesId": "Species",
    "broodStockProductId": "Broodstock",
    "feedingTrayCount": "Total Feeding Tray",
    "limitWeightPerArea": "Carrying Capacity (kg/m²)",
    "targetCultivationDay": "Target Cultivation Day (days)",
    "targetSize": "Target Count",
    "targetSurvivalRate": "Target SR (%)",
    "survivalRatePredictionMethod": "SR Prediction Method",
    "remark": "Notes (Optional)",
    "remarkPlaceholder": "Notes",
    "minimumFr": "FR table is not complete. Complete FR table until 60 here.",
    "warning": "Warning: Changing the start date may modify the day of cultivation and may affect the estimating calculation.",
    "cycleTooltip": "Write down cycle here",

    "idPlaceholder": "Select Cycle",
    "farmIdPlaceholder": "Select Farm",
    "pondIdPlaceholder": "Select Pond",
    "totalSeedPlaceholder": "Total Seed",
    "totalSeedTypePlaceholder": "Select Total Seed Type",
    "startedAtPlaceholder": "Started At",
    "finishedAtPlaceholder": "Finished At",
    "initialAgePlaceholder": "Optional",
    "preparationDayPlaceholder": "Optional",
    "hatcheryIdPlaceholder": "Select Hatchery",
    "speciesIdPlaceholder": "Select Species",
    "broodStockProductIdPlaceholder": "Select Broodstock",
    "feedingTrayCountPlaceholder": "Select feeding tray",
    "limitWeightPerAreaPlaceholder": " ",
    "targetCultivationDayPlaceholder": " ",
    "targetSizePlaceholder": " ",
    "targetSurvivalRatePlaceholder": " ",
    "area": "Area (m²)",
    "areaPlaceholder": " ",
    "deep": "Depth (m)",
    "deepPlaceholder": " ",
    "survivalRatePredictionMethodPlaceholder": "Select SR Prediction Method",

    "initialAgeHelper": "Initial age at started at",
    "targetSizeHelper": "DoC 100",

    "cycleClose": "Close Cycle",
    "targetAndCycles": "Cycle target and information",
    "targetSubtitle": "fill these form record based on your plan to make sure Jala calculation and prediction are optimum.",
    "nextPond": "Next Pond",

    "net": "Net",
    "gross": "Gross",
    "actual": "Actual",
    "netNote": "Amount you ordered",
    "grossNote": "Amount received from hatchery",
    "actualNote": "Actual amount counted",

    "fr": "Feed Ratio (FR)",
    "fixed": "Fixed",
    "ai": "By Measurements",
    "customFr": "Custom FR Table",
    "stpFr": "STP FR Table",
    "adg": "ADG",
    "aiCultivation": "Feed Ratio, Feeding Tray, Mortality",

    "cycle": "Cycle",
    "createCycle": "Create cycle",
    "updateCycle": "Save",

    "pond": "pond",
    "pondPlaceholder": "Choose pond",
    "seed": "Total seeds (pcs)",
    "seedPlaceholder": "Total seeds",
    "type": "type",
    "typePlaceholder": "Choose...",
    "hatchery": "hatchery",
    "hatcheryPlaceholder": "Choose...",
    "spread": "Spread day",
    "spreadPlaceholder": "Choose...",
    "species": "Species",
    "speciesPlaceholder": "Choose...",
    "tray": "Total trays",
    "trayPlaceholder": "Tray",
    "biomass": "biomass (kg/m²)",
    "biomassPlaceholder": "biomass",
    "targetDay": "Target day (days)",
    "targetDayPlaceholder": "Target day",
    "targetSr": "SR target (%)",
    "notes": "remark",
    "notesPlaceholder": "remark",

    "feedPrice": "Feed Price (for production cost estimation)",
    "feedPricePlaceholder": "Feed price",
  },

  "farmShrimpPriceForm": {
    "farmId": "Farm",
    "shrimpPriceId": "Select Location and Price",
    "shrimpPriceIdPrivate": "Select Location and Price Reference (optional)",
    "shrimpPriceSubtitle": "You can select a reference price location or create your own personal price",

    "farmIdPlaceholder": "Select Farm",
    "shrimpPriceIdPlaceholder": "Choose Location And Price",
    "shrimpPriceIdPrivatePlaceholder": "Choose Reference",

    "title": "Pricing your harvest with the actual shrimp price",
    "subtitle": "Connect the latest shrimp price with your farm. Jala will automatically calculate your selling price calculation based on the choosen price.",
    "helperText": "*Count 100 pcs/kg price based from your latest cycle start date at %{date}",
    "privateHelperText": "*Private shrimp price last update by: %{user} at : %{date}",

    "source": "Selling price source",
    "newest": "Newest Shrimp Price",
    "private": "Private Shrimp Price",
    "createNew": "Create New",

    "privateFormTitle": "Create Private Shrimp Price",
    "location": "Farm Location",
    "locationPlaceholder": "Input location",
    "currency": "Currency",
    "delete": "Delete Private Shrimp Price?",
    "info": "Saved private shrimp prices will not be displayed on the public shrimp prices page.",

    "createPrivateTitle": "Connect the estimated biomass with shrimp prices",
    "createPrivateSubtitle": "Jala will calculate the selling price of your shrimp based on the estimated biomass at the price of the selected shrimp.",
    "size100Validation": "count 100 is required to be filled",

    "deleteModalTitle": "Delete private shrimp price",
    "deleteModalSubtitle": "Are you sure to delete the data?",
    "emptyPrivatePriceTitle": "Private shrimp prices are not yet available",
    "emptyPrivatePriceSubtitle": "You can make a personal shrimp price list so that it can be connected to the estimated selling price",
    "dropdownPrivateTitle": "Choose Private Shrimp Price",
    "sizeInput": "Price and Count",
    "createdBy": "Created by: {{user}}",

    "privateShrimpPriceSaveTitle": "Save the Private Price?",
    "privateShrimpPriceSaveSubtitle": "Are you sure you want to save the private shrimp price?",
    "newestShrimpPriceSaveTitle": "Save Newest Price?",
    "newestShrimpPriceSaveSubtitle": "Are you sure you want to save the newest shrimp price?",
  },

  "waterQualityMultiMeasurementForm": {
    "farmId": "Farm",
    "batchId": "Batch",
    "pondId": "Pond",
    "cycleId": "Pond",
    "measuredDate": "Measured Date",
    "measuredTime": "Measured Time",
    "temperature": "Temperature (°C)",
    "ph": "pH",
    "salinity": "Salinity (ppt)",
    "do": "DO (mg/L)",
    "transparency": "Transparency (cm)",
    "waterLevel": "Water Level (cm)",
    "doPercent": "DO Percent (%)",
    "turbidity": "Turbidity (NTU)",
    "ec": "Electrical Conductivity (µS)",
    "color": "Water Color",
    "weather": "Weather",
    "measurementTooltip": "Write down water quality here",
    "orp": "ORP (mV)",

    "farmIdPlaceholder": "Select Farm",
    "batchIdPlaceholder": "Select Batch",
    "pondIdPlaceholder": "Select Pond",
    "cycleIdPlaceholder": "Select Pond",
    "measuredDatePlaceholder": "Measured Date",
    "measuredTimePlaceholder": "Measured Time",
    "temperaturePlaceholder": "-",
    "phPlaceholder": "-",
    "salinityPlaceholder": "-",
    "doPlaceholder": "-",
    "transparencyPlaceholder": "-",
    "waterLevelPlaceholder": "-",
    "doPercentPlaceholder": "-",
    "turbidityPlaceholder": "-",
    "ecPlaceholder": "-",
    "colorPlaceholder": "Select Color",
    "weatherPlaceholder": "Select Weather",
    "orpPlaceholder": "-",

    "waterQualityMultiMeasurement": "Water Quality",
    "otherParameters": "Other parameters",
  },
  "feedForm": {
    "farmId": "Farm",
    "cycleId": "Pond",
    "loggedDate": "Date",
    "loggedTime": "Time",
    "stockId": "Stock",
    "quantity": "Total Feed (kg)",
    "fasting": "Fasting",
    "remark": "Notes (Optional)",
    "feedTooltip": "Write down the Feed data you provide here",

    "farmIdPlaceholder": "Select Farm",
    "cycleIdPlaceholder": "Select Pond",
    "loggedDatePlaceholder": "Feed Date",
    "loggedTimePlaceholder": "Feed Time",
    "stockIdPlaceholder": "Select Stock",
    "quantityPlaceholder": " ",
    "remarkPlaceholder": "Note",

    "feeding": "Feeding"
  },
  "feedingTrayControlForm": {
    "farmId": "Farm",
    "cycleId": "Pond",
    "loggedDate": "Date",
    "loggedTime": "Checking Time",
    "feedLoggedAt": "Feeding Time",
    "datePlaceholder": "Date",
    "remark": "Notes (Optional)",
    "trayTooltip": "Write down checked data tray here",
    "remainFeed": "Select remain feed on the tray",

    "feedingTray": "Tray %{number}",

    "farmIdPlaceholder":"Select Farm",
    "cycleIdPlaceholder": "Select Pond",
    "loggedDatePlaceholder": "Select Date",
    "loggedTimePlaceholder": "Select Time",
    "feedLoggedAtPlaceholder": "Select Feeding Time",
    "remarkPlaceholder": "Note",
    "feedingTrayControlRemark": "*Leftover feed in Tray:",

    "feedingTrayControl": "Feeding Tray"
  },
  "samplingForm": {
    "farmId": "Farm",
    "cycleId": "Pond",
    "sampledAt": "Date",
    "files": "Photos",
    "averageWeight": "MBW (g)",
    "remark": "Notes (Optional)",
    "sampleTooltip": "Write down sampling data here",

    "farmIdPlaceholder":"Select Farm",
    "cycleIdPlaceholder": "Select Pond",
    "sampledAtPlaceholder": "Sampling Date",
    "averageWeightPlaceholder": " ",
    "filesPlaceholder": "Photos",
    "remarkPlaceholder": "Note",

    "sampling": "Sampling"
  },
  "treatmentForm": {
    "farmId": "Farm",
    "pondId": "Pond",
    "cycleId": "Pond",
    "stockId": "Stock",
    "name": "Treatment",
    "treatedAt": "Date",
    "quantity": "Quantity",
    "remark": "Notes (Optional)",
    "treatmentTooltip": "Write down treatment data on each pond",

    "farmIdPlaceholder":"Select Farm",
    "pondIdPlaceholder": "Select Pond",
    "cycleIdPlaceholder": "Select Pond",
    "stockIdPlaceholder": "Select Stock",
    "namePlaceholder": "Treatment",
    "treatedAtPlaceholder": "Select Date",
    "quantityPlaceholder": " ",
    "remarkPlaceholder": "Note",

    "treatment": "Treatment",

    "recordType": "Record Type",
    "radioBasic": "Text Note",
    "radioPro": "Using Treatment Product",
  },
  "harvestForm": {
    "farmId": "Farm",
    "cycleId": "Pond",
    "harvestedAt": "Date",
    "status": "Harvest Type",
    "weight": "Total Weight (kg)",
    "size": "Count (tail/kg)",
    "price": "Price per kg",
    "sellingPrice": "Total Price",
    "buyer": "Buyer (Optional)",
    "remark": "Notes (Optional)",
    "harvestTooltip": "Write down Harvest data here. You can choose type harvest partial, total, or fail",

    "farmIdPlaceholder":"Select Farm",
    "cycleIdPlaceholder": "Select Pond",
    "harvestedAtPlaceholder": "Harvest date",
    "statusPlaceholder": "Select Harvest Type",
    "weightPlaceholder": " ",
    "sizePlaceholder": " ",
    "pricePlaceholder": " ",
    "buyerPlaceholder": "Buyer",
    "remarkPlaceholder": "Note",

    "full": "Full",
    "partial": "Partial",
    "failed": "Failed",
    "harvest": "Harvest",
  },
  "mortalityForm": {
    "farmId": "Farm",
    "cycleId": "Pond",
    "recordedAt": "Date",
    "totalWeight": "Weight Total (kg)",
    "size": "Count (tail/kg)",
    "multiplier": "Multiplier",
    "quantityFinal": "Total Mortalities (tail)",
    "multiplierInfo": "Prediction potential mortality of unidentified shrimp.",
    "files": "Photos",
    "remark": "Notes (Optional)",
    "mortalityTooltip": "Write down mortality data here",
    "quantityPlaceholder": "0",

    "farmIdPlaceholder": "Select Farm",
    "cycleIdPlaceholder": "Select Pond",
    "recordedAtPlaceholder": "Select Date",
    "totalWeightPlaceholder": "0",
    "sizePlaceholder": "0",
    "multiplierPlaceholder": "E.g. 1.5",
    "filesPlaceholder": "Photos",
    "remarkPlaceholder": "Note",

    "mortality": "Mortality",

    "averageWeight": "MBW (g)",
    "quantity": "Total Quantity (estimation)",
    "basedOn": "Based On",
    "basedOnQuantity": "Quantity (pcs)",
    "basedOnSize": "Count"
  },
  "chemicalMultiMeasurementForm": {
    "farmId": "Farm",
    "batchId": "Batch",
    "pondId": "Pond",
    "cycleId": "Pond",
    "measuredDate": "Measured Date",
    "measuredTime": "Measured Time",
    "chemicalTooltip": "Write down chemical data here",

    "ammonia": "Ammonia (NH3) (ppm)",
    "nitrat": "Nitrate (NO3) (ppm)",
    "nitrit": "Nitrite (NO2) (ppm)",
    "alkalinity": "Alkalinity (ppm)",
    "hardness": "Hardness (ppm)",
    "calcium": "Calcium (Ca) (ppm)",
    "magnesium": "Magnesium (Mg) (ppm)",
    "carbonat": "Carbonate (CO3) (ppm)",
    "bicarbonat": "Bicarbonate (HCO3) (ppm)",
    "tom": "Total Organic Matter (TOM) (ppm)",
    "orp": "Oxidation-Reduction Potential (ORP) (mV)",
    "ammonium": "Ammonium (NH4) (ppm)",
    "phosphate": "Phosphate (PO4) (ppm)",
    "totalAmmonia": "Total Ammonia (ppm)",
    "potassium": "Potassium (ppm)",

    "farmIdPlaceholder": "Select Farm",
    "batchIdPlaceholder": "Select Batch",
    "pondIdPlaceholder": "Select Pond",
    "cycleIdPlaceholder": "Select Pond",
    "measuredDatePlaceholder": "Measured Date",
    "measuredTimePlaceholder": "Measured Time",

    "ammoniaPlaceholder": "-",
    "nitratPlaceholder": "-",
    "nitritPlaceholder": "-",
    "alkalinityPlaceholder": "-",
    "hardnessPlaceholder": "-",
    "calciumPlaceholder": "-",
    "magnesiumPlaceholder": "-",
    "carbonatPlaceholder": "-",
    "bicarbonatPlaceholder": "-",
    "tomPlaceholder": "-",
    "orpPlaceholder": "-",
    "ammoniumPlaceholder": "-",
    "phosphatePlaceholder": "-",
    "totalAmmoniaPlaceholder": "-",
    "potassiumPlaceholder": "-",

    "chemical": "Chemical"
  },
  "planktonMultiMeasurementForm": {
    "farmId": "Farm",
    "batchId": "Batch",
    "pondId": "Pond",
    "cycleId": "Pond",
    "measuredDate": "Measured Date",
    "measuredTime": "Measured Time",
    "planktonTooltip": "Write down plankton data here",

    "totalPlankton": "Total Plankton (Total) (cell/ml)",
    "ga": "Green Algae (GA) (cell/ml)",
    "bga": "Blue Green Algae (BGA) (cell/ml)",
    "dino": "Dinoflagellata (DINO) (cell/ml)",
    "diatom": "Diatom (cell/ml)",
    "prozoo": "Protozoa (PRO) (cell/ml)",
    "floc": "Floc (ml)",
    "gba": "Golden Brown Algae (GBA) (cell/ml)",
    "euglenophyta": "Euglenophyta (cell/ml)",
    "zoo": "Zoo (ZOO) (cell/ml)",
    "haptyophyta": "Haptyophyta (cell/ml)",
    "gga": "Golden Green Algae (GGA) (cell/ml)",
    "yga": "Yellow Green Algae (YGA) (cell/ml)",

    "farmIdPlaceholder": "Select Farm",
    "batchIdPlaceholder": "Select Batch",
    "pondIdPlaceholder": "Select Pond",
    "cycleIdPlaceholder": "Select Pond",
    "measuredDatePlaceholder": "Measured Date",
    "measuredTimePlaceholder": "Measured Time",

    "totalPlanktonPlaceholder": "-",
    "gaPlaceholder": "-",
    "bgaPlaceholder": "-",
    "dinoPlaceholder": "-",
    "diatomPlaceholder": "-",
    "prozooPlaceholder": "-",
    "flocPlaceholder": "-",
    "gbaPlaceholder": "-",
    "euglenophytaPlaceholder": "-",
    "zooPlaceholder": "-",
    "haptyophytaPlaceholder": "-",
    "ggaPlaceholder": "-",
    "ygaPlaceholder": "-",

    "plankton": "Plankton"
  },
  "microbiologyMultiMeasurementForm": {
    "farmId": "Farm",
    "batchId": "Batch",
    "pondId": "Pond",
    "cycleId": "Pond",
    "measuredDate": "Measured Date",
    "measuredTime": "Measured Time",
    "microbiologyTooltip": "Write down microbiology data here",

    "totalBacteria": "Total Bacteria (CFU/ml)",
    "totalVibrio": "Total Vibrio (CFU/ml)",
    "yellow": "Yellow Vibrio (CFU/ml)",
    "green": "Green Vibrio (CFU/ml)",
    "black": "Black (CFU/ml)",
    "luminance": "Luminance (CFU/ml)",

    "farmIdPlaceholder": "Select Farm",
    "batchIdPlaceholder": "Select Batch",
    "pondIdPlaceholder": "Select Pond",
    "cycleIdPlaceholder": "Select Pond",
    "measuredDatePlaceholder": "Measured Date",
    "measuredTimePlaceholder": "Measured Time",

    "totalBacteriaPlaceholder": "-",
    "totalVibrioPlaceholder": "-",
    "yellowPlaceholder": "-",
    "greenPlaceholder": "-",
    "blackPlaceholder": "-",
    "luminancePlaceholder": "-",

    "microbiology": "Microbiology"
  },
  "cycleDiseaseForm" : {
    "farmId": "Farm",
    "cycleId": "Pond",
    "loggedDate": "Date",
    "diseaseId": "Disease Name",
    "otherDisease": "Other Disease Name",
    "files": "Photos",
    "remark": "Notes (Optional)",
    "diseaseTooltip": "Write down result test disease here",
    "diseaseEvidence": "Upload photo infected shrimp as additional note",

    "farmIdPlaceholder": "Select Farm",
    "cycleIdPlaceholder": "Select Pond",
    "loggedDatePlaceholder": "Date",
    "diseaseIdPlaceholder": "Select Disease",
    "otherDiseasePlaceholder": "Other Disease",
    "filesPlaceholder": "Photos",
    "remarkPlaceholder": "Note",

    "cycleDisease": "Disease"
  },

  "simulationForm": {
    "name": "Simulation Name",
    "area": "Pond Area (m²)",
    "date": "Date",
    "seed": "Total Seed",
    "periode": "Harvest Period",
    "biomass": "Max Biomass (kg/m²)",
    "survival": "Target Survival Rate (%)",
    "size": "Count at days 100 (tail/kg)",
    "feed": "Feed Price Per-kg",
    "shouldBeFilled": "Should be filled",
    "shouldBeGreaterThan": "Should be greater than {{value}}",
    "shouldBeLessThan": "Should be less than {{value}}",
    "age": "Input age",
    "percent": "Input percentage",
    "namePlaceholder": `Simulation ${moment().format('YYYY-MM-DD')}`,
    "areaPlaceholder": "1.000 m²",
    "datePlaceholder": "Choose date",
    "seedPlaceholder": "100.000 tails",
    "perioderPlaceholder": "120 days",
    "biomassPlaceholder": "1.2 kg/m²",
    "survivalPlaceholder": "100%",
    "sizePlaceholder": "45",
    "feedPlaceholder": "Rp 15.000",
    "agePlaceholder": "Input age",
    "percentPlaceholder": "Input percentage"
  },

  "autoFeederDailyFeedForm": {
    "title": "Add Asto Feeding Data",
    "subtitle": "Feeding Details",
    "start": "Start",
    "end": "End",
    "quantity": "Feed",
    "quantitycontinuous": "Daily Total Feed",
    "remark": "Notes (optional)",
    "disclaimer": "Feeding data added in Asto will be connected to cultivation data in JALA",

    "remarkPlaceholder": "#AutoFeeder",
    "ratio": "Feeding ratio"
  }
}
